module.exports = __webpack_public_path__ + "static/media/cat-is-wrong.ead3793f.mp3";